import { ReservedResourceMultiInput } from 'src/api/api.generated'
import { ReservedResourceF } from '../../../types/reservation-detail.types'

export function reservedResourceToReservedResourceMultiInput(tenantId: string, rr: ReservedResourceF): ReservedResourceMultiInput {
  return {
    id: rr.id,
    reservedResource: {
      // productions: rr.productions.map((p) => {
      //   return {
      //     amount: Scalars['Float'];
      //     billId?: InputMaybe<Scalars['ID']>;
      //     chargeCategoryId: Scalars['ID'];
      //     currency: Scalars['Currency'];
      //     date: Scalars['Date'];
      //     description?: InputMaybe<Scalars['String']>;
      //     id: Scalars['ID'];
      //     quantity: Scalars['Int'];
      //     total: Scalars['Float'];
      //     vatId: Scalars['ID'];
      //   }
      // }),
      policy: rr.policy,
      guestOccupancies: rr.guestOccupancies?.map((go) => {
        return {
          cityTaxExoneration: go.cityTaxExoneration,
          end: go.end,
          guestId: go.guest.id,
          start: go.start,
          type: go.type,
        }
      }),
      additionalServices: rr.additionalServices?.map((as) => {
        return {
          additionalServiceId: as.additionalService.id,
          quantity: as.quantity,
        }
      }),
      adults: rr.adults,
      chargeCategoryId: rr.chargeCategory.id,
      childOccupancies: rr.childOccupancies?.map((c) => {
        return {
          childId: c.child.id,
          quantity: c.quantity,
        }
      }),
      children: rr.children,
      manualDailyPrices: rr.manualDailyPrices,
      manualPrice: rr.manualPrice,
      rateId: rr.rate.id,
      reservationId: rr.reservationId,
      resourceOccupancies: rr.resourceOccupancies.map((ro) => {
        return {
          end: ro.end,
          resourceId: ro.resource?.id,
          resourceTypeId: ro.reservedResourceType.id,
          start: ro.start,
        }
      }),
      tenantId: tenantId,
      chargeCategories: rr.chargeCategories,
    },
  }
}
